module.exports = __webpack_public_path__ + "img/lamp-floor.d48364d5.svg";